module.exports = __webpack_public_path__ + "img/xc1.cc87ddb9.png";